(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["soma-bundle-picker"] && !Shopify.designMode) return;
  try {
    class SomaBundlePicker extends HTMLElement {
    #section;

    connectedCallback() {
      this.#section = this.closest('.shopify-section');
      this.addEventListener('change', this.#handleChange);
      this.#section?.addEventListener('shopify:product:select', this.#handleProductSelection);
      this.#initialize();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#handleChange);
      this.#section?.removeEventListener('shopify:product:select', this.#handleProductSelection);
    }

    #getProductForm() {
      return this.#section?.querySelector('product-form-component');
    }

    #getCheckedQuantity() {
      return this.querySelector('.soma-bundle-picker__input:checked')?.value || '1';
    }

    #initialize() {
      const productForm = this.#getProductForm();
      const selectedVariant = productForm?.querySelector('input[name="id"]');

      if (!productForm || selectedVariant?.value !== this.dataset.standardVariantId) {
        this.hidden = true;
        return;
      }

      const search = new URLSearchParams(window.location.search);
      const quantity = Number.parseInt(search.get('quantity') || '', 10);
      const bundle = Number.parseInt(search.get('bundle') || '', 10);
      const selectedQuantity = search.get('variant') === this.dataset.standardVariantId
        && [1, 2, 3].includes(quantity)
        && quantity === bundle
        ? String(quantity)
        : this.#getCheckedQuantity();
      const selectedInput = this.querySelector(`.soma-bundle-picker__input[value="${selectedQuantity}"]`);

      if (selectedInput) selectedInput.checked = true;
      this.hidden = false;
      this.#setQuantity(selectedQuantity);
    }

    #handleChange = (event) => {
      const input = event.target;
      if (input instanceof HTMLInputElement && input.matches('.soma-bundle-picker__input') && input.checked) {
        this.#setQuantity(input.value);
      }
    };

    #handleProductSelection = (event) => {
      const selectedVariantId = event.detail?.variantId;

      if (typeof selectedVariantId === 'string') {
        this.hidden = String(selectedVariantId) !== this.dataset.standardVariantId;
      }

      event.promise
        ?.then(({ detail }) => {
          const isStandardVariant = String(detail?.resource?.id || '') === this.dataset.standardVariantId;
          this.hidden = !isStandardVariant;
          if (isStandardVariant) this.#setQuantity(this.#getCheckedQuantity());
        })
        .catch(() => {});
    };

    #setQuantity(quantity) {
      const productForm = this.#getProductForm();
      const selectedVariant = productForm?.querySelector('input[name="id"]');

      if (!productForm || selectedVariant?.value !== this.dataset.standardVariantId) return;

      customElements.whenDefined('quantity-selector-component').then(() => {
        const quantitySelector = productForm.querySelector('quantity-selector-component');
        const quantityInput = quantitySelector?.querySelector('input[name="quantity"]');

        if (!quantitySelector || !quantityInput || typeof quantitySelector.setValue !== 'function') return;

        quantitySelector.setValue(String(quantity));
        quantitySelector.updateButtonStates?.();
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

        const summary = this.querySelector('.soma-bundle-picker__summary');
        if (summary) {
          summary.textContent = this.dataset.summaryTemplate?.replace('__quantity__', String(quantity)) || '';
        }
      });
    }
  }

  if (!customElements.get('soma-bundle-picker')) {
    customElements.define('soma-bundle-picker', SomaBundlePicker);
  }
  } catch(e) { console.error(e); }
})();

})();
